<div class="table-body">
  <div class="row">
    <div class="col-12">
      <ng-select
        [multiple]="false"
        [items]="zones"
        bindLabel="zoneName"
        bindValue="zoneId"
        [loading]="isLoadingZones"
        [clearable]="true"
        class="zone-selector"
        [placeholder]="'comercial.prices.selectZonePlaceholder' | translate"
        [(ngModel)]="selectedZone"
        (ngModelChange)="filterDataByZone()"
      >
      </ng-select>
    </div>

    <div class="text-filter-description-container">
      <span>
        {{ "comercial.prices.selectZoneHint" | translate }}
      </span>
    </div>
  </div>

  <div *ngIf="isLoading" class="loader-container">
    <tui-loader size="l"></tui-loader>
  </div>

  <div
    class="zones-products-container mt-12"
    *ngIf="selectedZone && !isLoading"
  >
    <ng-container *ngIf="feeds && feeds.length > 0; else noFees">
      <div class="feeds-container">
        <div class="feeds-header">
          <img class="logo-header" src="/assets/img/tarifas.png" />
          <span class="title-header">{{
            "comercial.prices.sectionRatesTitle" | translate
          }}</span>
        </div>

        <div class="table-container mt-12">
          <table tuiTable size="l" [columns]="columns_tarifas">
            <thead>
              <tr tuiThGroup>
                <th
                  class="th-style"
                  *tuiHead="'fees'"
                  tuiTh
                  [sticky]="true"
                  (click)="setFeeSortColumn('feeName')"
                >
                  {{ "comercial.prices.tableHeaderFees" | translate }}
                </th>
                <th
                  class="th-style"
                  *tuiHead="'price'"
                  tuiTh
                  (click)="setFeeSortColumn('feePrice')"
                >
                  {{ "comercial.prices.tableHeaderPrice" | translate }}
                </th>
                <th class="th-style" *tuiHead="'actions'" tuiTh [sorter]="null">
                  {{ "comercial.prices.tableHeaderActions" | translate }}
                </th>
              </tr>
            </thead>
            <tbody tuiTbody *ngIf="sortedFeeds.length > 0">
              <tr tuiTr *ngFor="let f of sortedFeeds; trackBy: trackByFee">
                <td *tuiCell="'fees'" tuiTd>{{ translateFee(f.feeName) }}</td>
                <td *tuiCell="'price'" tuiTd>
                  {{ formatFeePrice(f.feePrice) }} {{ currency }}
                </td>
                <td *tuiCell="'actions'" tuiTd>
                  <tui-icon
                    icon="tuiIconEdit2"
                    class="pointer_item"
                    (click)="
                      openModal(
                        editClientPriceModal,
                        f.feeName,
                        formatFeePrice(f.feePrice)
                      )
                    "
                  ></tui-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <ng-template #noFees>
      <p class="text-center mt-16">
        {{ "comercial.prices.noFeesMessage" | translate }}
      </p>
    </ng-template>

    <ng-container
      *ngIf="verticalDetails && verticalDetails.length > 0; else noVerticals"
    >
      <div class="row mt-24">
        <div class="feeds-header">
          <img src="/assets/img/productos.png" width="26" />
          <span class="title-header">{{
            "comercial.prices.sectionProductsTitle" | translate
          }}</span>
          <hr />
        </div>
      </div>

      <div
        class="row"
        #verticalContainer
        *ngFor="let item of verticalDetails; trackBy: trackByVertical"
      >
        <div class="col-12 mb-6" *ngIf="verticalDetails.length > 0">
          <div class="product-header mt-24">
            <span class="product-title">
              {{
                historyService.translateVerticals(
                  translate.currentLang,
                  getVerticalRealName(item.verticalName)
                )
              }}
            </span>
            ({{ item.productDetails.length }})
            <tui-icon
              icon="tuiIconChevronRight"
              class="pointer_item"
              (click)="toggleSection(item.verticalName)"
              *ngIf="!isExpanded(item.verticalName)"
            ></tui-icon>
            <tui-icon
              icon="tuiIconChevronDown"
              class="pointer_item"
              (click)="toggleSection(item.verticalName)"
              *ngIf="isExpanded(item.verticalName)"
            ></tui-icon>
          </div>
        </div>

        <div class="col-12 mb-6" *ngIf="isExpanded(item.verticalName)">
          <ng-container
            *ngIf="editingVertical !== item.verticalName; else editButtons"
          >
            <button
              tuiButton
              appearance="outline"
              size="s"
              (click)="enterEditMode(item.verticalName)"
              class="edit-button"
              [disabled]="isSavingVertical || isToppingsSection(item.verticalName)"
            >
              {{ "comercial.prices.edit" | translate }}
            </button>
          </ng-container>

          <!-- Quizá esté en modo edición: muestro Guardar/Cancelar -->
          <ng-template #editButtons>
            <div class="edit-buttons-container">
              <button
                class="confirm-button"
                (click)="saveVerticalEdits(item.verticalName)"
                [disabled]="isSavingVertical"
              >
                <ng-container *ngIf="!isSavingVertical">
                  {{ "comercial.prices.save" | translate }}
                </ng-container>
                <ng-container *ngIf="isSavingVertical">
                  <tui-loader size="s"></tui-loader>
                </ng-container>
              </button>
              <button
                class="cancel-button"
                (click)="cancelEdit(item.verticalName)"
                [disabled]="isSavingVertical"
              >
                {{ "comercial.prices.cancel" | translate }}
              </button>
            </div>
          </ng-template>

          <div class="table-overflow" *ngIf="isExpanded(item.verticalName)">
            <table
              tuiTable
              size="l"
              class="table-container"
              [columns]="columns"
            >
              <thead class="mt-6">
                <tr tuiThGroup>
                  <th
                    class="th-style"
                    *tuiHead="'vertical'"
                    tuiTh
                    [sticky]="true"
                    (click)="setProductSortColumn('vertical')"
                  >
                    {{ "comercial.prices.headerProductColumn" | translate }}
                  </th>
                  <th
                    *tuiHead="'movi_b2c'"
                    tuiTh
                    class="th-style"
                    [sticky]="true"
                    (click)="setProductSortColumn('movi_b2c')"
                  >
                    {{ "comercial.prices.headerB2CMobility" | translate }}
                  </th>

                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <th
                      *tuiHead="'prov_b2c'"
                      tuiTh
                      class="th-style"
                      [sticky]="true"
                    >
                      {{ "comercial.prices.headerB2CProvider" | translate }}
                    </th>
                  </ng-container>

                  <th
                    *tuiHead="'movi_b2b'"
                    tuiTh
                    class="th-style"
                    [sticky]="true"
                    (click)="setProductSortColumn('movi_b2b')"
                  >
                    {{ "comercial.prices.headerB2BMobility" | translate }}
                  </th>

                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <th
                      *tuiHead="'prov_b2b'"
                      tuiTh
                      class="th-style"
                      [sticky]="true"
                    >
                      {{ "comercial.prices.headerB2BProvider" | translate }}
                    </th>
                  </ng-container>

                  <th
                    *tuiHead="'movi_pre'"
                    tuiTh
                    class="th-style"
                    [sticky]="true"
                    (click)="setProductSortColumn('movi_pre')"
                  >
                    {{ "comercial.prices.headerPremiumMobility" | translate }}
                  </th>

                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <th
                      *tuiHead="'prov_pre'"
                      tuiTh
                      class="th-style"
                      [sticky]="true"
                    >
                      {{ "comercial.prices.headerPremiumProvider" | translate }}
                    </th>
                  </ng-container>

                  <th
                    *tuiHead="'movi_hyb'"
                    tuiTh
                    class="th-style"
                    [sticky]="true"
                    (click)="setProductSortColumn('movi_hyb')"
                  >
                    {{ "comercial.prices.headerHybridMobility" | translate }}
                  </th>

                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <th
                      *tuiHead="'prov_hyb'"
                      tuiTh
                      class="th-style"
                      [sticky]="true"
                    >
                      {{ "comercial.prices.headerHybridProvider" | translate }}
                    </th>
                  </ng-container>
                </tr>
              </thead>

              <tbody tuiTbody>
                <tr
                  tuiTr
                  *ngFor="
                    let pr of getSortedProducts(item);
                    let rowIdx = index;
                    trackBy: trackByProductInSection
                  "
                >
                  <!-- Nombre del producto -->
                  <td *tuiCell="'vertical'" tuiTd class="td-style">
                    <div [tuiCell]="size">
                      <span tuiTitle>
                        {{
                          historyService.translate2(
                            translate.currentLang,
                            pr.productKey.split(" ")[0]
                          )
                        }}
                        {{ pr.productKey.split(" ")[1] }}
                      </span>
                    </div>
                  </td>

                  <!-- B2C Mobility -->
                  <td *tuiCell="'movi_b2c'" tuiTd class="td-style">
                    <ng-container
                      *ngIf="
                        editingVertical === item.verticalName;
                        else showB2C
                      "
                    >
                      <input
                        [formControl]="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2cMobility'
                          )
                        "
                        class="input_form"
                        placeholder="0.00"
                        inputmode="decimal"
                        maxlength="8"
                        [readonly]="isSavingVertical"
                      />
                      <div
                        *ngIf="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2cMobility'
                          ).invalid &&
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2cMobility'
                          ).dirty
                        "
                        class="error-message-container"
                      >
                        <span class="error-message">
                          {{ "comercial.prices.invalidPrice" | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #showB2C>
                      {{ formatFeePrice(pr.b2cMobilityPrice) }} {{ currency }}
                    </ng-template>
                  </td>

                  <!-- B2C Provider -->
                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <td *tuiCell="'prov_b2c'" tuiTd class="td-style">
                      <ng-container
                        *ngIf="
                          editingVertical === item.verticalName;
                          else showProvB2C
                        "
                      >
                        <input
                          [formControl]="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2cProvider'
                            )
                          "
                          class="input_form"
                          placeholder="0.00"
                          inputmode="decimal"
                          maxlength="8"
                          [readonly]="isSavingVertical"
                        />
                        <div
                          *ngIf="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2cProvider'
                            ).invalid &&
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2cProvider'
                            ).dirty
                          "
                          class="error-message-container"
                        >
                          <span class="error-message">
                            {{ "comercial.prices.invalidPrice" | translate }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #showProvB2C>
                        {{ formatFeePrice(pr.b2cProviderPrice) }} {{ currency }}
                      </ng-template>
                    </td>
                  </ng-container>

                  <!-- B2B Mobility -->
                  <td *tuiCell="'movi_b2b'" tuiTd class="td-style">
                    <ng-container
                      *ngIf="
                        editingVertical === item.verticalName;
                        else showB2B
                      "
                    >
                      <input
                        [formControl]="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2bMobility'
                          )
                        "
                        class="input_form"
                        placeholder="0.00"
                        inputmode="decimal"
                        maxlength="8"
                        [readonly]="isSavingVertical"
                      />
                      <div
                        *ngIf="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2bMobility'
                          ).invalid &&
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'b2bMobility'
                          ).dirty
                        "
                        class="error-message-container"
                      >
                        <span class="error-message">
                          {{ "comercial.prices.invalidPrice" | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #showB2B>
                      {{ formatFeePrice(pr.b2bMobilityPrice) }} {{ currency }}
                    </ng-template>
                  </td>

                  <!-- B2B Provider -->
                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <td *tuiCell="'prov_b2b'" tuiTd class="td-style">
                      <ng-container
                        *ngIf="
                          editingVertical === item.verticalName;
                          else showProvB2B
                        "
                      >
                        <input
                          [formControl]="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2bProvider'
                            )
                          "
                          class="input_form"
                          placeholder="0.00"
                          inputmode="decimal"
                          maxlength="8"
                          [readonly]="isSavingVertical"
                        />
                        <div
                          *ngIf="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2bProvider'
                            ).invalid &&
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'b2bProvider'
                            ).dirty
                          "
                          class="error-message-container"
                        >
                          <span class="error-message">
                            {{ "comercial.prices.invalidPrice" | translate }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #showProvB2B>
                        {{ formatFeePrice(pr.b2bProviderPrice) }} {{ currency }}
                      </ng-template>
                    </td>
                  </ng-container>

                  <!-- Premium Mobility -->
                  <td *tuiCell="'movi_pre'" tuiTd class="td-style">
                    <ng-container
                      *ngIf="
                        editingVertical === item.verticalName;
                        else showPRE
                      "
                    >
                      <input
                        [formControl]="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'premiumMobility'
                          )
                        "
                        class="input_form"
                        placeholder="0.00"
                        inputmode="decimal"
                        maxlength="8"
                        [readonly]="isSavingVertical"
                      />
                      <div
                        *ngIf="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'premiumMobility'
                          ).invalid &&
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'premiumMobility'
                          ).dirty
                        "
                        class="error-message-container"
                      >
                        <span class="error-message">
                          {{ "comercial.prices.invalidPrice" | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #showPRE>
                      {{ formatFeePrice(pr.premiumMobilityPrice) }} {{ currency }}
                    </ng-template>
                  </td>

                  <!-- Premium Provider -->
                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <td *tuiCell="'prov_pre'" tuiTd class="td-style">
                      <ng-container
                        *ngIf="
                          editingVertical === item.verticalName;
                          else showProvPRE
                        "
                      >
                        <input
                          [formControl]="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'premiumProvider'
                            )
                          "
                          class="input_form"
                          placeholder="0.00"
                          inputmode="decimal"
                          maxlength="8"
                          [readonly]="isSavingVertical"
                        />
                        <div
                          *ngIf="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'premiumProvider'
                            ).invalid &&
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'premiumProvider'
                            ).dirty
                          "
                          class="error-message-container"
                        >
                          <span class="error-message">
                            {{ "comercial.prices.invalidPrice" | translate }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #showProvPRE>
                        {{ formatFeePrice(pr.premiumProviderPrice) }} {{ currency }}
                      </ng-template>
                    </td>
                  </ng-container>

                  <!-- Hybrid Mobility -->
                  <td *tuiCell="'movi_hyb'" tuiTd class="td-style">
                    <ng-container
                      *ngIf="
                        editingVertical === item.verticalName;
                        else showHYB
                      "
                    >
                      <input
                        [formControl]="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'hybridMobility'
                          )
                        "
                        class="input_form"
                        placeholder="0.00"
                        inputmode="decimal"
                        maxlength="8"
                        [readonly]="isSavingVertical"
                      />
                      <div
                        *ngIf="
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'hybridMobility'
                          ).invalid &&
                          getProductControl(
                            item.verticalName,
                            rowIdx,
                            'hybridMobility'
                          ).dirty
                        "
                        class="error-message-container"
                      >
                        <span class="error-message">
                          {{ "comercial.prices.invalidPrice" | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #showHYB>
                      {{ formatFeePrice(pr.hybridMobilityPrice) }} {{ currency }}
                    </ng-template>
                  </td>

                  <!-- Hybrid Provider -->
                  <ng-container
                    *ngIf="shouldShowProviderColumns(item.verticalName)"
                  >
                    <td *tuiCell="'prov_hyb'" tuiTd class="td-style">
                      <ng-container
                        *ngIf="
                          editingVertical === item.verticalName;
                          else showProvHYB
                        "
                      >
                        <input
                          [formControl]="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'hybridProvider'
                            )
                          "
                          class="input_form"
                          placeholder="0.00"
                          inputmode="decimal"
                          maxlength="8"
                          [readonly]="isSavingVertical"
                        />
                        <div
                          *ngIf="
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'hybridProvider'
                            ).invalid &&
                            getProductControl(
                              item.verticalName,
                              rowIdx,
                              'hybridProvider'
                            ).dirty
                          "
                          class="error-message-container"
                        >
                          <span class="error-message">
                            {{ "comercial.prices.invalidPrice" | translate }}
                          </span>
                        </div>
                      </ng-container>
                      <ng-template #showProvHYB>
                        {{ formatFeePrice(pr.hybridProviderPrice) }} {{ currency }}
                      </ng-template>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12"><hr class="no-margin" /></div>
      </div>
    </ng-container>

    <ng-template #noVerticals>
      <p class="text-center mt-16">
        {{ "comercial.prices.noProductsSectionsMessage" | translate }}
      </p>
    </ng-template>
  </div>
</div>

<!-- =======================  MODAL TARIFA  ======================= -->
<ng-template #editClientPriceModal>
  <div class="modal-body-prices-table">
    <form [formGroup]="feedForm">
      <div class="modal-body-prices-table-header">
        <span class="modal-body-prices-table-title">
          {{ "comercial.prices.modalEdit" | translate }}
          {{ translateFee(activeEditPrice) }}
        </span>
        <button class="close-modal" (click)="bsModalRef?.hide()">×</button>
      </div>

      <div class="form-group">
        <label>{{ "comercial.prices.modalPriceLabel" | translate }}</label>
        <input
          type="text"
          formControlName="price"
          class="form-control"
          [placeholder]="'comercial.prices.modalPricePlaceholder' | translate"
          inputmode="decimal"
          maxlength="8"
          [readonly]="isLoadingEditFeed"
        />
        <div *ngIf="feedForm.get('price')?.invalid" class="text-danger mt-4">
          {{ "comercial.prices.invalidPrice" | translate }}
        </div>
      </div>

      <div class="modal-footer-prices-table">
        <button
          class="transparent-button"
          (click)="bsModalRef?.hide()"
          [disabled]="isLoadingEditFeed"
        >
          {{
            "detail_service.modals.modalDeletePenalization.cancelButton"
              | translate
          }}
        </button>

        <button
          class="green-button"
          (click)="saveModalFeeds()"
          [disabled]="feedForm.invalid || isLoadingEditFeed"
        >
          <ng-container *ngIf="!isLoadingEditFeed">
            {{
              "detail_service.modals.modalDeletePenalization.confirmButton"
                | translate
            }}
          </ng-container>
          <ng-container *ngIf="isLoadingEditFeed"
            ><tui-loader size="s"></tui-loader
          ></ng-container>
        </button>
      </div>
    </form>
  </div>
</ng-template>
